<template>
  <div v-if="hasLoaded" class="success">
    <header class="success__header">
      <dr-icon
        name="checkoutSuccess"
        class="success__icon"
      />

      <h3 class="success__heading">
        Assinatura realizada com sucesso!
      </h3>
    </header>

    <article class="success__body">
      <h4 class="success__msg">
        Parabéns, você já faz parte do nosso plano
        <strong class="text-green uppercase">
          {{ isMarketPlace ? 'MARKETPLACE': 'PREMIUM' }}
        </strong>
      </h4>

      <p class="success__text">
        A partir de agora, você tem acesso a todas as funcionalidades
        do nosso sistema e pode usufruir dos benefícios exclusivos já
        ativados em sua conta, entre eles:
      </p>

      <ul class="success__list">
        <li
          v-for="(feature, index) in features"
          :key="`feature-${index}`"
          class="success__item"
        >
          <i class="icon icon-check success__check" />

          {{ feature }}
        </li>
      </ul>

      <button
        class="btn btn-primary !w-48 mb-8"
        @click="$router.push({ name: 'DoctorAgenda' })"
      >
        Ver meu painel
      </button>
    </article>
  </div>
</template>

<script>
export default {
  name: 'PlansCheckoutSuccess',

  data () {
    return {
      isMarketPlace: false,
      hasLoaded: false
    }
  },

  created () {
    this.checkHealthplaceRequirements()
      .then((status) => {
        this.isMarketPlace = status
      })
      .finally(() => {
        this.hasLoaded = true
      })
  },

  computed: {
    features () {
      return this.isMarketPlace
        ? [...this.PLANS_DATA.features]
        : [...this.PLANS_DATA.features].slice(1)
    }
  },

  methods: {
    checkHealthplaceRequirements () {
      const url = '/doctor/doctor_health_place/has_agenda_available'

      return new Promise((resolve) => {
        this.$http
          .get(url, this.$store.getters.getAuthHeader)
          .then((res) => {
            resolve(Boolean(res.data))
          })
          .catch(() => resolve(false))
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '$vars';

.success {
  @apply w-full h-full;

  &__header {
    @apply p-6;
    @apply flex flex-row items-center justify-center;
    background: transparent linear-gradient(180deg, #5FCDC352 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box;
  }

  &__icon {
    @apply mr-3;
    max-height: 3rem;
    width: 3rem;
  }

  &__heading {
    @apply m-0 p-0;
    color: $color-green;
  }

  &__body {
    @apply w-full flex flex-col items-center justify-start;
  }

  &__msg {
    color: #444444;
    font-family: $font1;
  }

  &__text {
    @apply p-0 m-0 mt-3 mb-3;
    line-height: 1.8;
    max-width: 30rem;
    text-align: center;
  }

  &__list {
    @apply m-0 p-0 mb-4 list-none;
  }

  &__item {
    @apply m-0 p-0 mb-3;
    color: $color-blue;
  }

  &__check {
    @apply mr-1;
    color: #444;
    font-weight: 600;
  }
}
</style>
